import { Theme } from '@mui/material';
import { accordionClasses } from '@mui/material/Accordion';
import { typographyClasses } from '@mui/material/Typography';


const Accordion = (theme: Theme) => {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          border: '1px solid #e5e0dc',
          borderRadius: '8px',
          '::before': {
            display: 'none',
          },
          [`&.${accordionClasses.expanded}`]: {
            background: '#eeeee880',
            transition: 'background-color 200ms ease-out',
          },
          ':first-of-type, :last-of-type': {
            borderRadius: '8px',
          },
          '& + &': {
            marginTop: '16px',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        content: {
          [`& .${typographyClasses.root}`]: {
            fontWeight: 500,
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          color: theme.palette.text.secondary,
        },
      },
    },
  };
};

export default Accordion;
